// extracted by mini-css-extract-plugin
export default {"container":"search-bar_container__50amD"};